import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

import { meta, env } from '~/commons/config';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import { useModalAlert } from '../modals/ModalAlert.jsx';

import FormAnswer from '../forms/FormAnswer.jsx';
import FormBeforeAnswer from '../forms/FormBeforeAnswer.jsx';

const PageCompetition = () => {
  const history = useHistory();
  const [started, setStarted] = useState(false);
  const [res, req] = useHttpStatus();
  const [resComp, reqComp] = useHttpStatus();
  const [resAns, reqAns] = useHttpStatus();
  const { alert } = useModalAlert();

  useEffect(() => {
    reqComp({ url: 'api/quiz/competitions/self' });
  }, []);

  useEffect(() => {
    if (resComp.status === 'success') {
      const comp = resComp.payload;
      if (comp.answers?.[0] || !comp?.allow?.allowed) {
        history.push('/app');
      }
    }
  }, [resComp.status]);

  useEffect(() => {
    if (started) {
      if (env?.config?.USE_TOKEN_FOR_COMPETITION) {
        req({ url: 'api/core/users/self/tokens' })
          .then((res) => {
            axios.defaults.headers.common.Authorization = `Bearer ${res.payload.access}`;
            reqAns({
              url: 'api/quiz/answers',
              method: 'post',
            });
          })
          .catch((err) => {
            console.log(err);
            reqAns({
              url: 'api/quiz/answers',
              method: 'post',
            });
          });
      } else {
        reqAns({
          url: 'api/quiz/answers',
          method: 'post',
        });
      }
    }
  }, [started]);

  useEffect(() => {
    if (resAns.status === 'error') {
      alert((
        <div className="text-danger">{resAns.payload}</div>
      ));
      history.push('/app');
    }
  }, [resAns.status]);

  return (
    <PageHttp res={resComp}>
      {(competition) => {
        meta.set({ title: competition.title });

        if (!started) {
          return (
            <FormBeforeAnswer
              competition={competition}
              onSubmit={() => setStarted(true)}
            />
          );
        }

        return (
          <PageHttp res={resAns}>
            {(doc) => {
              console.log('[PageCompetition] answer doc received', doc);
              const answerObj = doc.answer || doc;

              let competitionProp = doc.competition || resComp.payload || {};
              console.log(competitionProp);
              if (doc.competition && resComp.payload && Array.isArray(resComp.payload.questions) && Array.isArray(doc.competition.questions)) {
                const annotatedMap = new Map(resComp.payload.questions.map((q) => [String(q._id), q]));
                const docMap = new Map(doc.competition.questions.map((q) => [String(q._id), q]));

                const ordered = [];
                const used = new Set();
                resComp.payload.questions.forEach((q) => {
                  const id = String(q._id);
                  const original = docMap.get(id);
                  if (original) {
                    const ann = annotatedMap.get(id);
                    ordered.push(ann ? {
                      ...original, challenge: ann.challenge, questionSet: ann.questionSet, qSetCode: ann.qSetCode,
                    } : original);
                    used.add(id);
                  }
                });

                doc.competition.questions.forEach((q) => {
                  const id = String(q._id);
                  if (!used.has(id)) ordered.push(q);
                });

                competitionProp = {
                  ...doc.competition,
                  questions: ordered,
                };
              }

              return (
                  <FormAnswer
                    answer={answerObj}
                    competition={competitionProp}
                  />
              );
            }}
          </PageHttp>
        );
      }}
    </PageHttp>
  );
};

export default PageCompetition;
